// src/components/Modal.jsx
// Updating form: Modal (generic dialog with escape-to-close and click handling)
import React, { useEffect } from "react";

export default function Modal({ title, onClose = () => {}, children, footer }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" role="presentation">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title || "Dialog"}
        className="surface relative w-[min(860px,92vw)] rounded-hard p-0 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-edge">
          <h3 className="text-ice text-lg font-semibold">{title}</h3>
          <button className="chip px-3 py-1" onClick={onClose} aria-label="Close">Close</button>
        </div>
        <div className="p-5">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-edge flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
